import ComptabiliteModuleLayout from "@features/comptabilite/components/ComptabiliteModuleLayout";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { CalculatorIcon } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite")({
  staticData: {
    title: "Comptabilité",
    icon: CalculatorIcon,
    permission: PERMISSIONS.COMPTABILITE.RELANCES.VIEW,
    module: "comptabilite",
    section: "Comptabilité",
    order: 28,
    showInNav: false,
  },
  component: ComptabiliteModuleLayout,
});
